import { dispatch } from 'nike-re-framejs';
import { getScrollTop } from './helpers/scroll';

const responsiveSaveScrollTop = value => db => db.setIn(['responsive', 'lastScrollTop'], value);

export const responsiveGetScrollTop = () => dispatch(responsiveSaveScrollTop(getScrollTop()));
// subs for tablet cha
